import { getNumberWithCommas } from './getNumberWithCommas';

/**
 * 配列に変換する
 * @param number 数値
 */
export const convertIntoArray = (number: number | undefined) => {
  if (number == null) return [];

  const numberWithCommas = getNumberWithCommas(number);
  const convertIntoArray = numberWithCommas.split('');

  return convertIntoArray;
};
